import { useLocation } from 'react-router-dom';

import { FormSubmitButton } from '../../components/Button/PrimaryButton';
import { FormComponent } from '../../components/FormCom/FormComponent';
import { HideableTextFormField } from '../../components/FormCom/HideableTextFormField';
import useAuth from '../../hooks/useAuth';
import {
  ISigupPasswordChange,
  signUpPaswordChangeDataType,
  signUpPaswordChangeInitialValues,
  signUpPaswordChangeSchema,
} from '../../models/auth/signUpPaswordChange.model';

export const SignUpPasswordChange = () => {
  const location = useLocation();
  const { loading, signupSetUserPaswd } = useAuth();

  const onSubmit = async (values: signUpPaswordChangeDataType) => {
    const userId = location.state?.data;
    const data: ISigupPasswordChange = {
      userId,
      password: values.password,
    };
    signupSetUserPaswd(data);
  };

  return (
    <FormComponent
      initialValues={signUpPaswordChangeInitialValues}
      schema={signUpPaswordChangeSchema}
      onSubmit={onSubmit}
    >
      <HideableTextFormField
        label="Password"
        name="password"
        type="password"
        placeholder="Password"
      />

      <HideableTextFormField
        label="Confirm Password"
        name="confirmPassword"
        type="password"
        placeholder="Confirm Password"
      />

      <FormSubmitButton className="spanTwo" type="submit" showIcon={loading}>
        Set Password
      </FormSubmitButton>
    </FormComponent>
  );
};
